const Eye = () => (
  <svg
    width="65"
    height="64"
    viewBox="0 0 65 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M56.6667 0H8.66675C4.24847 0 0.666748 3.58172 0.666748 8V56.0001C0.666748 60.4184 4.24847 64.0001 8.66675 64.0001H56.6667C61.085 64.0001 64.6667 60.4184 64.6667 56.0001V8C64.6667 3.58172 61.085 0 56.6667 0Z"
      fill="#F4EFED"
    />
    <path
      d="M32.6672 8.53369C47.6828 8.53379 60.3919 18.403 64.6653 32.0083C60.3921 45.6139 47.6831 55.4838 32.6672 55.4839C17.6512 55.4839 4.94137 45.6141 0.668213 32.0083C4.94157 18.4028 17.6515 8.53369 32.6672 8.53369Z"
      fill="white"
    />
    <circle cx="32.6668" cy="32" r="11.2" fill="#0A0777" />
  </svg>
);

export default Eye;
